import { ControlProperty, ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { DEFAULT_PAGE_SIZE, ListQueryParam } from '../../../../../common/constants';
import { Validators } from '@angular/forms';

export class TruckDriversSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;
  hubId: string;
  carrierExtId: string;
  firstName: string;
  lastName: string;
  idType: string;
  idNumber: string;
  phoneNumber: string;

  constructor(params?: TruckDriversSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface TruckDriverBrief {
  firstName: string;
  lastName: string;
  idTypes: string[];
  idNumbers: string[];
  phoneNumbers: string[];
  carrierExtIds: string[];
  frequentDriverIds: number[];
  truckIds: number[];
  tourExecutionIds: number[];
  canBeDeleted: boolean;
}

export class TruckDriverSearchModel {
  firstName: string;
  lastName: string;
  hubId: string;
}

export class TruckDriverSearchForm {
  constructor(
    model: TruckDriverSearchModel,
    public firstName: ControlProperty<string> = model.firstName,
    public lastName: ControlProperty<string> = model.lastName,
    public hubId: ControlProperty<string> = [model.hubId, Validators.required],
  ) {}
}
